
import {Component , ViewChild} from '@angular/core';
import {
  NavController,
  ToastController,
  AlertController,
  Content,
  MenuController,
  Events,
  ModalController,
  Alert,
  NavParams
} from 'ionic-angular';
import {SearchPage} from "../search/search";
import {CustomerWishListPage} from "../customer-wish-list/customer-wish-list";
import {STOCKCART, RECEIVESTOCKLOCATION, REFERENCE, WORKORDER, loginUserInfo} from "../../providers/data";
import { BarcodeScanner} from 'ionic-native';
import { Http, Headers, RequestOptions} from '@angular/http';
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import {IMAGES_BASE_URL,ApplicationVariables} from '../../providers/config';
import {CustomerCarts} from '../../providers/user-cart-provider/user-carts';
import {ItemsPage} from '../items/items';
import {LoginPage} from '../login/login';
import {MyOrderPage} from '../my-order/my-order';
import {Constants} from '../../providers/config';
import 'rxjs/add/operator/map';
import {GVLogger} from '../../services/gv-logger';
import { MsgManager } from '../../providers/msg-manager';
import { ItemPage } from '../item-details/item-details';
import { Storage } from '@ionic/storage';
import {File} from '@ionic-native/file';
import { StockcartManager } from '../../providers/stockcart-manager';
import { ThankYouModalPage } from '../thank-you-modal/thank-you-modal';
import {CartManager} from "../../providers/cart-manager";
import { LicenseStatusModelPage } from '../license-status-model/license-status-model';
import { LocationCodeModelPage } from '../location-code-model/location-code-model';
import {ReceiveStockPopupPage} from "../receive-stock-popup/receive-stock-popup";
import {ReferenceListPage} from "../reference-list/reference-list";
import { LocationsListPage } from '../locations-list/locations-list';
import {MoveProductLocationModelPage} from "../move-product-location-model/move-product-location-model";
import {MarkBadProductModelPage} from "../mark-bad-product-model/mark-bad-product-model";
import {SuppliersListPage} from "../suppliers-list/suppliers-list";
import {WarehousesListPage} from "../warehouses-list/warehouses-list";
import {WorkOrdersPage} from "../work-orders/work-orders";

@Component({
  selector: 'page-stockcart',
  templateUrl: 'stockcart.html',
})
export class StockcartPage {

  isWebstore = 0;
  isOfflineMode:any = false;

  public constants = Constants;
  public multipleCarts = false;
  public cart: any;
  public TotalPrice:number = 0;
  public TotalPriceBeforeTax:number = 0;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  public barCodeFocus = "Keep focus here to scan QR/Scan Code.";
   @ViewChild('barcodeFocus') barCodeFocusInput ;
   @ViewChild(Content) content: Content;
   taxPercent = 0; // changed from  0.13
   TAX = 0;
   public locationSelected = 0;
   haveTitle:boolean = false;
   cartTitleTemp:string = "";
   orderStatus:number;
   cacheImages:any;
  quantity: any;
  updateButtonStatus = true;
  isLoading = true;
  reference = null;
  po = "";
  shipment = "";
  supplierName = "";
  productLocation = "";
  // productWarehouse = "";
  productLocationCode = "";
  referenceStatus = true;
  referenceTypeCheck = true;

  items = [];
  suppliers = [];
  selectedSupplier
  selectedSupplierCompany = ""

  resultsAvailable: boolean = false;
  results: string[] = [];
  ignoreNextChange: boolean = false;
  locationPopUpOpenStatus: boolean = false;
  warehousePopUpOpenStatus: boolean = false;
  badProductConditionsList = [];
  lotNumber;
  autoImportStatus = false;
  // productWarehouseId = 0;
  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName

  calledFrom = ""
  skusJson

  constructor(
          public nav: NavController,
          private stockCartManager: StockcartManager,
          public http: Http,
          public api:Api,
          public toastCtrl:ToastController,
          public menuController:MenuController,
          public alertCtrl: AlertController,
          public menu:MenuController,
          public customerCarts:CustomerCarts,
          public events:Events,
          private gVLogger:GVLogger,
          private msgManager:MsgManager,
          private modalController:ModalController,
          private apiOffline:ApiOffline,
          private storage:Storage,
          private file: File,
          private modalCtrl:ModalController,
          private cartManager:CartManager,
          public params:NavParams,
        ) {

          try{
            if(this.reference.trim() === ""){
              this.reference = null;
            }

          }catch(err){
            this.gVLogger.log("errrrroeerrrrrr : " + err);

          }

          if(this.reference != "" && this.reference != null){
            this.referenceStatus = false;
          }

          this.calledFrom = this.params.get("calledFrom")
          this.skusJson = this.params.get("skusJson")


    if(this.calledFrom === 'workOrder'){
      this.getItemsIfCalledFromWorkOrder();
    }

    this.storage.get("cacheImages").then((cache)=>{
     this.cacheImages = cache;
   });

    this.isOfflineMode = ApplicationVariables.isOffline;

    if(Constants.isWebstore){
      this.isWebstore = 1;
    }

    this.getLookupBadProductConditions();

    this.cart = STOCKCART;
    if(REFERENCE.productsreference != "" || REFERENCE.productsreference != null){
      this.gVLogger.log("reference in the dta file : " + JSON.stringify(REFERENCE));
      this.reference = REFERENCE.productsreference;
      this.referenceStatus = false;
    }

    if(REFERENCE.productsreference == "" || REFERENCE.productsreference == null){
      this.referenceStatus = true;
    }

    if(RECEIVESTOCKLOCATION.productsLocation != "" || RECEIVESTOCKLOCATION.productsLocation != null){
      this.gVLogger.log("location in the dta file : " + JSON.stringify(RECEIVESTOCKLOCATION));
      this.productLocation = RECEIVESTOCKLOCATION.productsLocation;
    }
    // this.stockCartManager.removeJunkFromCart();

     this.orderStatus = this.stockCartManager.getOrderStatus();
     this.cartTitleTemp = this.stockCartManager.getOrderTitle();

    this.events.publish("titleChange");

    if(this.cartTitleTemp != ""){
      this.haveTitle = true;
    }

    this.events.subscribe("titleChange" ,()=>{
      this.gVLogger.log(this.stockCartManager.getOrderTitle());
      this.cartTitleTemp = this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle());
     // this.gVLogger.log("title changed : " ,this.cartTitleTemp);
      if(this.cartTitleTemp == ""){
       this.haveTitle = false;
      }else{
        this.haveTitle = true;
      }
    });

    this.refreshTotalPrice();
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;

    if(!Constants.isWebstore && !ApplicationVariables.isOffline){
      this.getCustomerCarts(0);
    }

    this.updateButtonStatus = true;
    this.isLoading = true;

    this.events.subscribe("cartUpdated",()=>{
      this.refreshTotalPrice();
    });


      if(WORKORDER.jobReference !== ""){
        this.reference = WORKORDER.jobReference;
        this.stockCartManager.setReference(WORKORDER.jobReference);
        this.referenceStatus = false;
        WORKORDER.jobReference = "";
      }

  }




  initializeItemsOnFocus() {

    if(this.referenceStatus === true){
      this.referenceStatus = false;
    this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

    let ref = "";
    try{
      ref = this.reference.trim();
    }
    catch (e) {
      ref = null;
    }

    if(ref !== "" && ref !== null){
      this.api.get("products/getReferencNo/"+ref)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            this.items = [];
            for(let item of data.data){
              this.items.push(item.referenceNo);
              this.gVLogger.log("daaaattaaaaa : " + this.items);
            }

            let model = this.modalController.create(ReferenceListPage, {items: this.items});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                this.reference = data;
                this.stockCartManager.setReference(data);
                this.referenceStatus = false;
              }
              else {
                this.referenceStatus = true;
              }
            });
            model.present();

            this.items = [];
          }

        });
    }

    else if(this.cart.items.length < 1 && (ref === null || ref === "")){
      this.gVLogger.log("if extecuted in getReferencNo");
      let searchString = -1;
      this.api.get("products/getReferencNo/"+searchString)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            for(let item of data.data){
              this.items.push(item.referenceNo);
              this.gVLogger.log("daaaattaaaaa : " + item);
            }
            let model = this.modalController.create(ReferenceListPage, {items: this.items});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                this.reference = data;
                this.stockCartManager.setReference(data);
                this.referenceStatus = false;
              }
              else {
                this.referenceStatus = true;
              }
            });
            model.present();
            this.items = [];
          }

        });
    }

    else if (this.cart.items.length === 1 && (ref === null || ref === "")){
      this.gVLogger.log("if executed getproductReferencesByProductId");
     let searchString = this.cart.items[0].id;
      this.api.get("products/getproductReferencesByProductId/" + searchString)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if (data.status === "200") {
            for (let item of data.data) {
              this.items.push(item);
              this.gVLogger.log("daaaattaaaaa : " + item);
            }

            let model = this.modalController.create(ReferenceListPage, {items: this.items});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                this.reference = data;
                this.stockCartManager.setReference(data);
                this.referenceStatus = false;
              }
              else {
                this.referenceStatus = true;
              }
            });
            model.present();

            this.items = [];
          }
        });
    }
    }
    else {
      this.msgManager.toastMsg("Not allowed! Please rest to change it.");
    }
  }



  getLocationsOnFocus() {

    if(this.locationPopUpOpenStatus == false){
      this.locationPopUpOpenStatus = true;
    this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

    let loc = "";

      loc = "-1";

      this.api.get("products/getLocationsByAdpCustomerId/?searchString="+ loc)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            this.items = [];
            for(let item of data.data){
              // let loc = item.name + " (" + item.locationCode + ")";

              let loc = {name : item.name, locationCode : item.locationCode}
              this.items.push(loc);
              this.gVLogger.log("daaaattaaaaa : " + this.items);
            }

            let model = this.modalController.create(LocationsListPage, {items: this.items, searchString: loc});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                // this.productLocation = data;
                this.productLocation = data.name + " (" + data.locationCode + ")";
                this.productLocationCode = data.locationCode;
                this.stockCartManager.setLocation(data.locationCode);

              }
              else {

              }
            });
            model.present();

            this.items = [];
          }

        });

        setTimeout(() => {
          this.locationPopUpOpenStatus = false;
        },500)


  }
  else{

  }
  }

  // getWarehousesOnFocus() {
  //
  //   if(this.warehousePopUpOpenStatus == false){
  //     this.productLocation = "";
  //     this.productLocationCode = "";
  //     this.warehousePopUpOpenStatus = true;
  //
  //     let loc = "";
  //
  //     loc = "-1";
  //
  //     this.api.get("locations/getAllParentLocationAgainstAdpCustomer")
  //       .map(res => res.json())
  //       .subscribe(data => {
  //         if(data.status === "200"){
  //           this.items = [];
  //           for(let item of data.data){
  //             // let loc = item.name + " (" + item.locationCode + ")";
  //
  //             let loc = {id : item.id, name : item.name, locationCode : item.locationCode}
  //             this.items.push(loc);
  //             this.gVLogger.log("daaaattaaaaa : " + this.items);
  //           }
  //
  //           let model = this.modalController.create(WarehousesListPage, {items: this.items, searchString: loc});
  //           model.onDidDismiss(data => {
  //             this.gVLogger.log("data on dismiss : " + data);
  //             if(data !== "" && data != null){
  //               // this.productLocation = data;
  //               this.productWarehouse = data.name + " (" + data.locationCode + ")";
  //               this.productWarehouseId = data.id;
  //               // this.stockCartManager.setLocation(data.locationCode);
  //
  //             }
  //             else {
  //
  //             }
  //           });
  //           model.present();
  //
  //           this.items = [];
  //         }
  //
  //       });
  //
  //     setTimeout(() => {
  //       this.warehousePopUpOpenStatus = false;
  //     },500)
  //
  //
  //   }
  //   else{
  //
  //   }
  // }

  search(val){
    this.gVLogger.log("search called" + val);
  }

  removeFocus(){
    this.gVLogger.log("remove focus called");
  }

   ionViewDidLoad(){

    setTimeout(() => {
      // Keyboard.show() // for android
      if(!Constants.isWebstore){
        // alert("sada");
        this.barCodeFocusInput.setFocus();
      }
    },800); //a least 150ms.
  //  this.gVLogger.log("Ion view loaded");
 }


 checkReferenceTypeOfCartProducts(){
   this.gVLogger.log("callllllleddd : " + this.cart.items.length);
   if(this.stockCartManager.getProductsCount() < 1){
    this.referenceStatus = true;
   }
   for(let item of this.cart.items){
     if(item.referenceNumber != "" && this.stockCartManager.getProductsCount() >= 1){
      this.gVLogger.log("if callllllleddd : " + this.stockCartManager.getProductsCount());
       this.referenceStatus = false;
       return;
     }
     else{
      this.gVLogger.log("else callllllleddd : " + this.stockCartManager.getProductsCount());
       this.referenceStatus = true;
     }
   }

 }

updateProductInCart(product){
  if(String(product.quantity) !=""){
    if(String(product.quantity).match(/^\d+$/)){
        this.stockCartManager.updateCartNew(product);
      }else{
        product.quantity = Number(product.quantity);
        this.stockCartManager.updateCartNew(product);
      }
    }else{
        product.quantity = Number(product.quantity);
        this.stockCartManager.updateCartNew(product);
    }
  this.refreshTotalPrice();

  }


   selectAll(event){
    event.target.select();
   }


  addFromBarCode(event){
    event.target.value = event.target.value.trim();
    if(this.autoImportStatus){
      setTimeout(()=>{
        let barCode=event.target.value;
        if(event.target.value !== ""){


          let body = {barCode: barCode, isWebstore: this.isWebstore, refNo : "-1"};
          // let body = {barCode: barCode, isWebstore: this.isWebstore, refNo : reff};
          this.api.post("products/getProductByBarcode", body)
            // this.api.get("products/getProductByBarcode/?barcode="+barCode+"&isWebStore="+this.isWebstore+"&refNo="+reff)
            .map(res => res.json())
            .subscribe(data => {
              if (data.status == "401") { // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                setTimeout(() => {
                  event.target.value = "";
                  event.target.focus();
                }, 500)

                this.nav.setRoot(LoginPage);
              } else if (data.status == 200) {

                let refer = "";
                try{
                  refer = this.reference.trim();
                }
                catch (e) {
                  refer = null;
                }


                  if (data.data.productType === 0) {
                    // if(data.data.referenceNumber !== this.reference ){
                    //   this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                    //   return;
                    // }
                    let receiceStockModal = this.modalController.create(ReceiveStockPopupPage, {item: data.data}, {cssClass: 'receiceStockModall'});
                    receiceStockModal.onDidDismiss(dataformPopUp => {

                      if (dataformPopUp !== undefined) {
                        // try {
                        //   if (this.reference.trim() === "") {
                        //     this.reference = null;
                        //   }
                        //
                        // } catch (err) {
                        //   this.gVLogger.log("errrrroeerrrrrr : " + err);
                        //
                        // }


                        // let ref = dataformPopUp.referenceNumber.trim();
                        // if (ref != "" && (this.reference === "" || this.reference === null)) {
                          if (dataformPopUp.id != 0) {
                            if (dataformPopUp.qtyONHAND > 0) {
                              this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                            }

                            let markBadList = [];
                            for(let badInventory of this.badProductConditionsList) {
                              let badProductObj = {
                                code: badInventory.code,
                                type: badInventory.desctiption,
                                quantity: 0,
                                comment: ""
                              };
                              markBadList.push(badProductObj);
                            }

                            dataformPopUp.badProductDtoList = markBadList;


                            if(this.stockCartManager.getProductsLengthInsideCart() > 0){
//                               if(dataformPopUp.supplierId === this.cart.items[0].supplierId){
                                this.addProductToCartFromPopUp(dataformPopUp);
//                               }else {
//                                 this.msgManager.toastMsg("Product has a different supplier!")
// ;                              }
                            }else {
                              this.addProductToCartFromPopUp(dataformPopUp);
                              this.selectedSupplierCompany =  dataformPopUp.supplierCompany;

                              let supplier = {id:dataformPopUp.supplierId,company:dataformPopUp.supplierCompany,supplierUuid:dataformPopUp.supplierUuid}
                              this.stockCartManager.setSupplier(supplier);
                            }

                            this.scrollBottom();
                            // setTimeout(()=>{
                            event.target.value = "";
                            event.target.focus();

                          } else if (dataformPopUp.status === "0") {

                            this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                            setTimeout(() => {
                              event.target.value = "";
                              event.target.focus();
                            }, 500)

                          }
                          setTimeout(() => {
                            event.target.value = "";
                            event.target.focus();
                          }, 500)

                      }
                      // },500);
                    });
                    receiceStockModal.present();
                  } else {

                    //  case when product type is one of its kind and then cart size is greater than 0;

                    data.data.quantity = data.data.totalQuantityShipmentNotice;


                      this.gVLogger.log("if product location called....");


                      if (data.data.id != 0) {
                        if (data.data.qtyONHAND > 0) {
                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                        }

                        let markBadList = [];
                        for(let badInventory of this.badProductConditionsList) {
                          let badProductObj = {
                            code: badInventory.code,
                            type: badInventory.desctiption,
                            quantity: 0,
                            comment: ""
                          };
                          markBadList.push(badProductObj);
                        }

                        data.data.badProductDtoList = markBadList;


                        if(this.stockCartManager.getProductsLengthInsideCart() > 0){
                          // if(data.data.supplierId === this.cart.items[0].supplierId){
                            this.addProductToCart(data.data);
                          // }else {
                          //   this.msgManager.toastMsg("Product has a different supplier!")
                          //   ;                              }
                        }else {
                          this.addProductToCart(data.data);
                          this.selectedSupplierCompany =  data.data.supplierCompany;

                          let supplier = {id:data.data.supplierId,company:data.data.supplierCompany,supplierUuid:data.data.supplierUuid}
                          this.stockCartManager.setSupplier(supplier);
                        }


                        // this.addProductToCart(data.data);
                        this.scrollBottom();
                        // setTimeout(()=>{
                        event.target.value = "";
                        event.target.focus();
                        // },500);

                        // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                      } else if (data.data.status === "0") {

                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                        setTimeout(() => {
                          event.target.value = "";
                          event.target.focus();
                        }, 500)

                      }
                      setTimeout(() => {
                        event.target.value = "";
                        event.target.focus();
                      }, 500)
                      //alert("Product added successfully.");



                  }

                // }

              }else if(data.status == "404"){

                this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
                setTimeout(()=>{
                  event.target.value = "";
                  event.target.focus();
                },500)

              }
            });
          setTimeout(()=>{
            event.target.value = "";
            event.target.focus();
          },500);
        }
      },400);
    }else {
      setTimeout(()=>{
        let barCode=event.target.value;
        if(event.target.value !== ""){
          let reff = "";
          try{
            reff = this.reference.trim();
            let replaceStr = /\#/gi;
            // reff = reff.replace(replaceStr, "%23");
          }
          catch (e) {
            reff = null;
          }
          if(reff === "" || reff === null){
            reff = "-1";
          }

          let body = {barCode: barCode, isWebstore: this.isWebstore, refNo : reff};
          this.api.post("products/getProductByBarcode", body)
            // this.api.get("products/getProductByBarcode/?barcode="+barCode+"&isWebStore="+this.isWebstore+"&refNo="+reff)
            .map(res => res.json())
            .subscribe(data => {
              if (data.status == "401") { // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                setTimeout(() => {
                  event.target.value = "";
                  event.target.focus();
                }, 500)

                this.nav.setRoot(LoginPage);
              } else if (data.status == 200) {

                let refer = "";
                try{
                  refer = this.reference.trim();
                }
                catch (e) {
                  refer = null;
                }

                if (this.cart.items.length < 1 && (refer === "" || refer === null) ) {
                  this.gVLogger.log("if extecuted in getReferencNo");
                  let searchString = data.data.id;
                  this.api.get("products/getproductReferencesByProductId/" + searchString)
                    .map(res => res.json())
                    .subscribe(data => {
                      if(data.status == "401"){ // check for session out
                        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                        this.nav.setRoot(LoginPage);
                      }
                      if (data.status === "200") {
                        for (let item of data.data) {
                          this.items.push(item);
                        }
                        let model = this.modalController.create(ReferenceListPage, {items: this.items, productRefSearch: 1, productId: searchString});
                        model.onDidDismiss(dataa => {
                          if (dataa !== "" && dataa != null) {
                            this.reference = dataa;
                            this.stockCartManager.setReference(dataa);
                            this.referenceStatus = false;

                            // let replaceStr = /\#/gi;
                            // let referenceForUrl = dataa.replace(replaceStr, "%23");

                            let bodyy = {barCode: barCode, isWebstore: this.isWebstore, refNo : dataa};
                            this.api.post("products/getProductByBarcode", bodyy)
                              // this.api.get("products/getProductByBarcode/?barcode=" + barCode + "&isWebStore=" + this.isWebstore + "&refNo=" + referenceForUrl)
                              .map(res => res.json()).subscribe(getProductByBarcodeData => {
                              let dataformPopUp = getProductByBarcodeData.data;

                              if (dataformPopUp.productType === 0) {
                                let receiceStockModal = this.modalController.create(ReceiveStockPopupPage, {item: dataformPopUp}, {cssClass: 'receiceStockModall'});
                                receiceStockModal.onDidDismiss(dataformPopUp => {

                                  if (dataformPopUp !== undefined) {
                                    try {
                                      if (this.reference.trim() === "") {
                                        this.reference = null;
                                      }

                                    } catch (err) {
                                      this.gVLogger.log("errrrroeerrrrrr : " + err);

                                    }


                                    let ref = dataformPopUp.referenceNumber.trim();
                                    if (ref != "" && (this.reference === "" || this.reference === null)) {//NR

                                      if (dataformPopUp.id != 0) {
                                        if (dataformPopUp.qtyONHAND > 0) {
                                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                        }


                                        let markBadList = [];
                                        for(let badInventory of this.badProductConditionsList) {
                                          let badProductObj = {
                                            code: badInventory.code,
                                            type: badInventory.desctiption,
                                            quantity: 0,
                                            comment: ""
                                          };
                                          markBadList.push(badProductObj);
                                        }

                                        dataformPopUp.badProductDtoList = markBadList;

                                        this.addProductToCartFromPopUp(dataformPopUp);
                                        this.scrollBottom();
                                        event.target.value = "";
                                        event.target.focus();

                                      } else if (dataformPopUp.status === "0") {

                                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                        setTimeout(() => {
                                          event.target.value = "";
                                          event.target.focus();
                                        }, 500)

                                      }
                                      setTimeout(() => {
                                        event.target.value = "";
                                        event.target.focus();
                                      }, 500)


                                    } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                                      let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                                        title: "Empty Ref#!",
                                        message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                                      });
                                      refModel.present();

                                      // this.msgManager.toastMsg("Reference# should not be empty!");
                                      setTimeout(() => {
                                        event.target.value = "";
                                        event.target.focus();
                                      }, 500)

                                    } else if (ref === this.reference || ref === "") {
                                      if (ref === this.reference) {
                                        this.referenceStatus = false;
                                      }


                                      if (dataformPopUp.id != 0) {
                                        if (dataformPopUp.qtyONHAND > 0) {
                                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                        }

                                        let markBadList = [];
                                        for(let badInventory of this.badProductConditionsList) {
                                          let badProductObj = {
                                            code: badInventory.code,
                                            type: badInventory.desctiption,
                                            quantity: 0,
                                            comment: ""
                                          };
                                          markBadList.push(badProductObj);
                                        }

                                        dataformPopUp.badProductDtoList = markBadList;

                                        this.addProductToCart(dataformPopUp);
                                        this.scrollBottom();
                                        event.target.value = "";
                                        event.target.focus();
                                      } else if (dataformPopUp.status === "0") {

                                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                        setTimeout(() => {
                                          event.target.value = "";
                                          event.target.focus();
                                        }, 500)

                                      }
                                      setTimeout(() => {
                                        event.target.value = "";
                                        event.target.focus();
                                      }, 500)

                                    } else {
                                      this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                                      setTimeout(() => {
                                        event.target.value = "";
                                        event.target.focus();
                                      }, 500)
                                    }
                                  }
                                });
                                receiceStockModal.present();
                              }
                              else{
                                dataformPopUp.quantity = dataformPopUp.totalQuantityShipmentNotice;
                                try {
                                  if (this.reference.trim() === "") {
                                    this.reference = null;
                                  }

                                } catch (err) {
                                  this.gVLogger.log("errrrroeerrrrrr : " + err);
                                }

                                let ref = dataformPopUp.referenceNumber.trim();
                                if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                                  if (dataformPopUp.id != 0) {
                                    if (dataformPopUp.qtyONHAND > 0) {
                                      this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                    }

                                    let markBadList = [];
                                    for(let badInventory of this.badProductConditionsList) {
                                      let badProductObj = {
                                        code: badInventory.code,
                                        type: badInventory.desctiption,
                                        quantity: 0,
                                        comment: ""
                                      };
                                      markBadList.push(badProductObj);
                                    }

                                    dataformPopUp.badProductDtoList = markBadList;

                                    this.addProductToCart(dataformPopUp);
                                    this.scrollBottom();
                                    event.target.value = "";
                                    event.target.focus();


                                  } else if (dataformPopUp.status === "0") {

                                    this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                    setTimeout(() => {
                                      event.target.value = "";
                                      event.target.focus();
                                    }, 500)

                                  }
                                  setTimeout(() => {
                                    event.target.value = "";
                                    event.target.focus();
                                  }, 500)


                                } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                                  let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                                    title: "Empty Ref#!",
                                    message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                                  });
                                  refModel.present();

                                  setTimeout(() => {
                                    event.target.value = "";
                                    event.target.focus();
                                  }, 500)

                                } else if (ref === this.reference || ref === "") {
                                  if (ref === this.reference) {
                                    this.referenceStatus = false;
                                  }


                                  if (dataformPopUp.id != 0) {
                                    if (dataformPopUp.qtyONHAND > 0) {
                                      this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                    }

                                    let markBadList = [];
                                    for(let badInventory of this.badProductConditionsList) {
                                      let badProductObj = {
                                        code: badInventory.code,
                                        type: badInventory.desctiption,
                                        quantity: 0,
                                        comment: ""
                                      };
                                      markBadList.push(badProductObj);
                                    }

                                    dataformPopUp.badProductDtoList = markBadList;

                                    this.addProductToCart(dataformPopUp);
                                    this.scrollBottom();
                                    // setTimeout(()=>{
                                    event.target.value = "";
                                    event.target.focus();

                                  } else if (dataformPopUp.status === "0") {

                                    this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                    setTimeout(() => {
                                      event.target.value = "";
                                      event.target.focus();
                                    }, 500)

                                  }
                                  setTimeout(() => {
                                    event.target.value = "";
                                    event.target.focus();
                                  }, 500)
                                  //alert("Product added successfully.");

                                } else {
                                  this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                                  setTimeout(() => {
                                    event.target.value = "";
                                    event.target.focus();
                                  }, 500)
                                }
                              }
                            })
                          }
                        });
                        model.present();

                        this.items = [];
                      } else {
                        // Else is required from PMG
                      }

                    });
                } else {
                  if (data.data.productType === 0) {
                    if(data.data.referenceNumber !== this.reference ){
                      this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      return;
                    }
                    let receiceStockModal = this.modalController.create(ReceiveStockPopupPage, {item: data.data}, {cssClass: 'receiceStockModall'});
                    receiceStockModal.onDidDismiss(dataformPopUp => {



                      if (dataformPopUp !== undefined) {
                        try {
                          if (this.reference.trim() === "") {
                            this.reference = null;
                          }

                        } catch (err) {
                          this.gVLogger.log("errrrroeerrrrrr : " + err);

                        }


                        let ref = dataformPopUp.referenceNumber.trim();
                        if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                          this.gVLogger.log("UIUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU" + JSON.stringify(dataformPopUp))
                          if (dataformPopUp.id != 0) {
                            if (dataformPopUp.qtyONHAND > 0) {
                              this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                            }

                            let markBadList = [];
                            for(let badInventory of this.badProductConditionsList) {
                              let badProductObj = {
                                code: badInventory.code,
                                type: badInventory.desctiption,
                                quantity: 0,
                                comment: ""
                              };
                              markBadList.push(badProductObj);
                            }

                            dataformPopUp.badProductDtoList = markBadList;


                            this.addProductToCartFromPopUp(dataformPopUp);
                            this.scrollBottom();
                            // setTimeout(()=>{
                            event.target.value = "";
                            event.target.focus();

                          } else if (dataformPopUp.status === "0") {

                            this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                            setTimeout(() => {
                              event.target.value = "";
                              event.target.focus();
                            }, 500)

                          }
                          setTimeout(() => {
                            event.target.value = "";
                            event.target.focus();
                          }, 500)
                          //alert("Product added successfully.");


                        } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                          let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                            title: "Empty Ref#!",
                            message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                          });
                          refModel.present();

                          // this.msgManager.toastMsg("Reference# should not be empty!");
                          setTimeout(() => {
                            event.target.value = "";
                            event.target.focus();
                          }, 500)

                        } else if (ref === this.reference || ref === "") {
                          if (ref === this.reference) {
                            this.referenceStatus = false;
                          }

                          if (dataformPopUp.id != 0) {
                            if (dataformPopUp.qtyONHAND > 0) {
                              this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                            }

                            let markBadList = [];
                            for(let badInventory of this.badProductConditionsList) {
                              let badProductObj = {
                                code: badInventory.code,
                                type: badInventory.desctiption,
                                quantity: 0,
                                comment: ""
                              };
                              markBadList.push(badProductObj);
                            }

                            dataformPopUp.badProductDtoList = markBadList;

                            this.gVLogger.log("okkkkkkkkkkkkkkkkkkkkkkkkkkkkk" + JSON.stringify(dataformPopUp))
                            this.addProductToCartFromPopUp(dataformPopUp);
                            this.scrollBottom();
                            // setTimeout(()=>{
                            event.target.value = "";
                            event.target.focus();

                            // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                          } else if (dataformPopUp.status === "0") {

                            this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                            setTimeout(() => {
                              event.target.value = "";
                              event.target.focus();
                            }, 500)

                          }
                          setTimeout(() => {
                            event.target.value = "";
                            event.target.focus();
                          }, 500)
                          //alert("Product added successfully.");

                        } else {
                          this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                          setTimeout(() => {
                            event.target.value = "";
                            event.target.focus();
                          }, 500)
                        }
                      }
                      // },500);
                    });
                    receiceStockModal.present();
                  } else {

                    //  case when product type is one of its kind and then cart size is greater than 0;

                    if(data.data.referenceNumber !== this.reference ){
                      this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      return;
                    }
                    data.data.quantity = data.data.totalQuantityShipmentNotice;
                    try {
                      if (this.reference.trim() === "") {
                        this.reference = null;
                      }

                    } catch (err) {
                      this.gVLogger.log("errrrroeerrrrrr : " + err);

                    }

                    let ref = data.data.referenceNumber.trim();
                    if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                      this.gVLogger.log("if product location called....");
                      this.referenceStatus = false;
                      this.reference = ref;
                      this.productLocation = data.data.locationCode;
                      this.referenceStatus = false;

                      data.data.quantity = data.data.totalQuantityShipmentNotice; //UD

                      if (data.data.id != 0) {
                        if (data.data.qtyONHAND > 0) {
                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                        }

                        let markBadList = [];
                        for(let badInventory of this.badProductConditionsList) {
                          let badProductObj = {
                            code: badInventory.code,
                            type: badInventory.desctiption,
                            quantity: 0,
                            comment: ""
                          };
                          markBadList.push(badProductObj);
                        }

                        data.data.badProductDtoList = markBadList;

                        this.addProductToCart(data.data);
                        this.scrollBottom();
                        // setTimeout(()=>{
                        event.target.value = "";
                        event.target.focus();
                        // },500);

                        // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                      } else if (data.data.status === "0") {

                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                        setTimeout(() => {
                          event.target.value = "";
                          event.target.focus();
                        }, 500)

                      }
                      setTimeout(() => {
                        event.target.value = "";
                        event.target.focus();
                      }, 500)
                      //alert("Product added successfully.");


                    } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                      let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                        title: "Empty Ref#!",
                        message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                      });
                      refModel.present();

                      // this.msgManager.toastMsg("Reference# should not be empty!");
                      setTimeout(() => {
                        event.target.value = "";
                        event.target.focus();
                      }, 500)

                    } else if (ref === this.reference || ref === "") {
                      if (ref === this.reference) {
                        this.referenceStatus = false;
                      }

                      data.data.quantity = data.data.totalQuantityShipmentNotice; //UD
                      if (data.data.id != 0) {
                        if (data.data.qtyONHAND > 0) {
                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                        }

                        let markBadList = [];
                        for(let badInventory of this.badProductConditionsList) {
                          let badProductObj = {
                            code: badInventory.code,
                            type: badInventory.desctiption,
                            quantity: 0,
                            comment: ""
                          };
                          markBadList.push(badProductObj);
                        }

                        data.data.badProductDtoList = markBadList;

                        this.addProductToCart(data.data);
                        this.scrollBottom();
                        // setTimeout(()=>{
                        event.target.value = "";
                        event.target.focus();
                        // },500);

                        // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                      } else if (data.data.status === "0") {

                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                        setTimeout(() => {
                          event.target.value = "";
                          event.target.focus();
                        }, 500)

                      }
                      setTimeout(() => {
                        event.target.value = "";
                        event.target.focus();
                      }, 500)
                      //alert("Product added successfully.");

                    } else {
                      this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      setTimeout(() => {
                        event.target.value = "";
                        event.target.focus();
                      }, 500)
                    }
                  }

                }

              }else if(data.status == "404"){

                this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
                setTimeout(()=>{
                  event.target.value = "";
                  event.target.focus();
                },500)

              }
            });
          setTimeout(()=>{
            event.target.value = "";
            event.target.focus();
          },500);
        }
      },400);
    }


      setTimeout(()=>{
        event.target.value = "";
        event.target.focus();
      },500);
      this.scrollBottom();



  }

  getItemsIfCalledFromWorkOrder(){
    if(this.skusJson !== undefined && this.skusJson !== null){
      let skus = JSON.parse(this.skusJson);
      for(let sku of skus){

        console.log("stringgggg " + JSON.stringify(sku))
        this.addFromBarCodeInCaseOfWorkOrder(sku.upcCode, sku.quantityPicked);
      }
    }
  }


  addFromBarCodeInCaseOfWorkOrder(value, quantityPicked){
    // event.target.value = event.target.value.trim();
      setTimeout(()=>{
        let barCode=value;
        if(value !== ""){
          let reff = "";
          try{
            reff = this.reference.trim();
            let replaceStr = /\#/gi;
            // reff = reff.replace(replaceStr, "%23");
          }
          catch (e) {
            reff = null;
          }
          if(reff === "" || reff === null){
            reff = "-1";
          }

          let body = {barCode: barCode, isWebstore: this.isWebstore, refNo : reff};
          this.api.post("products/getProductByBarcode", body)
            // this.api.get("products/getProductByBarcode/?barcode="+barCode+"&isWebStore="+this.isWebstore+"&refNo="+reff)
            .map(res => res.json())
            .subscribe(data => {
              if (data.status == "401") { // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                // setTimeout(() => {
                  // event.target.value = "";
                  // event.target.focus();
                // }, 500)

                this.nav.setRoot(LoginPage);
              } else if (data.status == 200) {

                data.data.quantity = quantityPicked
                let refer = "";
                try{
                  refer = this.reference.trim();
                }
                catch (e) {
                  refer = null;
                }

                if (this.cart.items.length < 1 && (refer === "" || refer === null) ) {
                  this.gVLogger.log("if extecuted in getReferencNo");
                  let searchString = data.data.id;
                  this.api.get("products/getproductReferencesByProductId/" + searchString)
                    .map(res => res.json())
                    .subscribe(data => {
                      if(data.status == "401"){ // check for session out
                        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                        this.nav.setRoot(LoginPage);
                      }
                      if (data.status === "200") {
                        for (let item of data.data) {
                          this.items.push(item);
                        }
                        let model = this.modalController.create(ReferenceListPage, {items: this.items, productRefSearch: 1, productId: searchString});
                        model.onDidDismiss(dataa => {
                          if (dataa !== "" && dataa != null) {
                            this.reference = dataa;
                            this.stockCartManager.setReference(dataa);
                            this.referenceStatus = false;

                            // let replaceStr = /\#/gi;
                            // let referenceForUrl = dataa.replace(replaceStr, "%23");

                            let bodyy = {barCode: barCode, isWebstore: this.isWebstore, refNo : dataa};
                            this.api.post("products/getProductByBarcode", bodyy)
                              // this.api.get("products/getProductByBarcode/?barcode=" + barCode + "&isWebStore=" + this.isWebstore + "&refNo=" + referenceForUrl)
                              .map(res => res.json()).subscribe(getProductByBarcodeData => {
                              let dataformPopUp = getProductByBarcodeData.data;
                              dataformPopUp.quantity = quantityPicked

                              if (dataformPopUp.productType === 0) {
                                // let receiceStockModal = this.modalController.create(ReceiveStockPopupPage, {item: dataformPopUp}, {cssClass: 'receiceStockModall'});
                                // receiceStockModal.onDidDismiss(dataformPopUp => {

                                  if (dataformPopUp !== undefined) {
                                    try {
                                      if (this.reference.trim() === "") {
                                        this.reference = null;
                                      }

                                    } catch (err) {
                                      this.gVLogger.log("errrrroeerrrrrr : " + err);

                                    }


                                    let ref = dataformPopUp.referenceNumber.trim();
                                    if (ref != "" && (this.reference === "" || this.reference === null)) {//NR

                                      if (dataformPopUp.id != 0) {
                                        if (dataformPopUp.qtyONHAND > 0) {
                                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                        }


                                        let markBadList = [];
                                        for(let badInventory of this.badProductConditionsList) {
                                          let badProductObj = {
                                            code: badInventory.code,
                                            type: badInventory.desctiption,
                                            quantity: 0,
                                            comment: ""
                                          };
                                          markBadList.push(badProductObj);
                                        }

                                        dataformPopUp.badProductDtoList = markBadList;

                                        this.addProductToCartFromPopUp(dataformPopUp);
                                        this.scrollBottom();
                                        // event.target.value = "";
                                        // event.target.focus();

                                      } else if (dataformPopUp.status === "0") {

                                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                        // setTimeout(() => {
                                          // event.target.value = "";
                                          // event.target.focus();
                                        // }, 500)

                                      }
                                      // setTimeout(() => {
                                        // event.target.value = "";
                                        // event.target.focus();
                                      // }, 500)


                                    } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                                      let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                                        title: "Empty Ref#!",
                                        message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                                      });
                                      refModel.present();

                                      // this.msgManager.toastMsg("Reference# should not be empty!");
                                      // setTimeout(() => {
                                      //   event.target.value = "";
                                      //   event.target.focus();
                                      // }, 500)

                                    } else if (ref === this.reference || ref === "") {
                                      if (ref === this.reference) {
                                        this.referenceStatus = false;
                                      }


                                      if (dataformPopUp.id != 0) {
                                        if (dataformPopUp.qtyONHAND > 0) {
                                          this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                        }

                                        let markBadList = [];
                                        for(let badInventory of this.badProductConditionsList) {
                                          let badProductObj = {
                                            code: badInventory.code,
                                            type: badInventory.desctiption,
                                            quantity: 0,
                                            comment: ""
                                          };
                                          markBadList.push(badProductObj);
                                        }

                                        dataformPopUp.badProductDtoList = markBadList;

                                        this.addProductToCart(dataformPopUp);
                                        this.scrollBottom();
                                        // event.target.value = "";
                                        // event.target.focus();
                                      } else if (dataformPopUp.status === "0") {

                                        this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                        // setTimeout(() => {
                                        //   event.target.value = "";
                                        //   event.target.focus();
                                        // }, 500)

                                      }
                                      // setTimeout(() => {
                                      //   event.target.value = "";
                                      //   event.target.focus();
                                      // }, 500)

                                    } else {
                                      this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                                      // setTimeout(() => {
                                      //   event.target.value = "";
                                      //   event.target.focus();
                                      // }, 500)
                                    }
                                  }
                                // });
                                // receiceStockModal.present();
                              }
                              else{
                                dataformPopUp.quantity = dataformPopUp.totalQuantityShipmentNotice;
                                try {
                                  if (this.reference.trim() === "") {
                                    this.reference = null;
                                  }

                                } catch (err) {
                                  this.gVLogger.log("errrrroeerrrrrr : " + err);
                                }

                                let ref = dataformPopUp.referenceNumber.trim();
                                if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                                  if (dataformPopUp.id != 0) {
                                    if (dataformPopUp.qtyONHAND > 0) {
                                      this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                    }

                                    let markBadList = [];
                                    for(let badInventory of this.badProductConditionsList) {
                                      let badProductObj = {
                                        code: badInventory.code,
                                        type: badInventory.desctiption,
                                        quantity: 0,
                                        comment: ""
                                      };
                                      markBadList.push(badProductObj);
                                    }

                                    dataformPopUp.badProductDtoList = markBadList;

                                    this.addProductToCart(dataformPopUp);
                                    this.scrollBottom();
                                    // event.target.value = "";
                                    // event.target.focus();


                                  } else if (dataformPopUp.status === "0") {

                                    this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                    // setTimeout(() => {
                                    //   event.target.value = "";
                                    //   event.target.focus();
                                    // }, 500)

                                  }
                                  // setTimeout(() => {
                                  //   event.target.value = "";
                                  //   event.target.focus();
                                  // }, 500)


                                } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                                  let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                                    title: "Empty Ref#!",
                                    message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                                  });
                                  refModel.present();

                                  // setTimeout(() => {
                                  //   event.target.value = "";
                                  //   event.target.focus();
                                  // }, 500)

                                } else if (ref === this.reference || ref === "") {
                                  if (ref === this.reference) {
                                    this.referenceStatus = false;
                                  }


                                  if (dataformPopUp.id != 0) {
                                    if (dataformPopUp.qtyONHAND > 0) {
                                      this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                                    }

                                    let markBadList = [];
                                    for(let badInventory of this.badProductConditionsList) {
                                      let badProductObj = {
                                        code: badInventory.code,
                                        type: badInventory.desctiption,
                                        quantity: 0,
                                        comment: ""
                                      };
                                      markBadList.push(badProductObj);
                                    }

                                    dataformPopUp.badProductDtoList = markBadList;

                                    this.addProductToCart(dataformPopUp);
                                    this.scrollBottom();
                                    // setTimeout(()=>{
                                    // event.target.value = "";
                                    // event.target.focus();

                                  } else if (dataformPopUp.status === "0") {

                                    this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                                    // setTimeout(() => {
                                    //   event.target.value = "";
                                    //   event.target.focus();
                                    // }, 500)

                                  }
                                  // setTimeout(() => {
                                  //   event.target.value = "";
                                  //   event.target.focus();
                                  // }, 500)
                                  //alert("Product added successfully.");

                                } else {
                                  this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                                  // setTimeout(() => {
                                  //   event.target.value = "";
                                  //   event.target.focus();
                                  // }, 500)
                                }
                              }
                            })
                          }
                        });
                        model.present();

                        this.items = [];
                      } else {
                        // Else is required from PMG
                      }

                    });
                } else {
                  if (data.data.productType === 0) {
                    if(data.data.referenceNumber !== this.reference ){
                      // this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      return;
                    }
                    // let receiceStockModal = this.modalController.create(ReceiveStockPopupPage, {item: data.data}, {cssClass: 'receiceStockModall'});
                    // receiceStockModal.onDidDismiss(dataformPopUp => {

                    let dataformPopUp = data.data



                      if (dataformPopUp !== undefined) {
                        try {
                          if (this.reference.trim() === "") {
                            this.reference = null;
                          }

                        } catch (err) {
                          this.gVLogger.log("errrrroeerrrrrr : " + err);

                        }


                        let ref = dataformPopUp.referenceNumber.trim();
                        if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                          this.gVLogger.log("UIUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU" + JSON.stringify(dataformPopUp))
                          if (dataformPopUp.id != 0) {
                            if (dataformPopUp.qtyONHAND > 0) {
                              // this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                            }

                            let markBadList = [];
                            for(let badInventory of this.badProductConditionsList) {
                              let badProductObj = {
                                code: badInventory.code,
                                type: badInventory.desctiption,
                                quantity: 0,
                                comment: ""
                              };
                              markBadList.push(badProductObj);
                            }

                            dataformPopUp.badProductDtoList = markBadList;


                            this.addProductToCartFromPopUp(dataformPopUp);
                            this.scrollBottom();
                            // setTimeout(()=>{
                            // event.target.value = "";
                            // event.target.focus();

                          } else if (dataformPopUp.status === "0") {

                            // this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                            // setTimeout(() => {
                            //   event.target.value = "";
                            //   event.target.focus();
                            // }, 500)

                          }
                          // setTimeout(() => {
                          //   event.target.value = "";
                          //   event.target.focus();
                          // }, 500)
                          //alert("Product added successfully.");


                        } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                          let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                            title: "Empty Ref#!",
                            message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                          });
                          refModel.present();

                          // this.msgManager.toastMsg("Reference# should not be empty!");
                          // setTimeout(() => {
                          //   event.target.value = "";
                          //   event.target.focus();
                          // }, 500)

                        } else if (ref === this.reference || ref === "") {
                          if (ref === this.reference) {
                            this.referenceStatus = false;
                          }

                          if (dataformPopUp.id != 0) {
                            if (dataformPopUp.qtyONHAND > 0) {
                              // this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                            }

                            let markBadList = [];
                            for(let badInventory of this.badProductConditionsList) {
                              let badProductObj = {
                                code: badInventory.code,
                                type: badInventory.desctiption,
                                quantity: 0,
                                comment: ""
                              };
                              markBadList.push(badProductObj);
                            }

                            dataformPopUp.badProductDtoList = markBadList;

                            this.gVLogger.log("okkkkkkkkkkkkkkkkkkkkkkkkkkkkk" + JSON.stringify(dataformPopUp))
                            this.addProductToCartFromPopUp(dataformPopUp);
                            this.scrollBottom();
                            // setTimeout(()=>{
                            // event.target.value = "";
                            // event.target.focus();

                            // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                          } else if (dataformPopUp.status === "0") {

                            // this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                            // setTimeout(() => {
                            //   event.target.value = "";
                            //   event.target.focus();
                            // }, 500)

                          }
                          // setTimeout(() => {
                          //   event.target.value = "";
                          //   event.target.focus();
                          // }, 500)
                          //alert("Product added successfully.");

                        } else {
                          // this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                          // setTimeout(() => {
                          //   event.target.value = "";
                          //   event.target.focus();
                          // }, 500)
                        }
                      }
                      // },500);
                    // });
                    // receiceStockModal.present();
                  } else {

                    //  case when product type is one of its kind and then cart size is greater than 0;

                    if(data.data.referenceNumber !== this.reference ){
                      // this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      return;
                    }
                    data.data.quantity = data.data.totalQuantityShipmentNotice;
                    try {
                      if (this.reference.trim() === "") {
                        this.reference = null;
                      }

                    } catch (err) {
                      this.gVLogger.log("errrrroeerrrrrr : " + err);

                    }

                    let ref = data.data.referenceNumber.trim();
                    if (ref != "" && (this.reference === "" || this.reference === null)) {//NR
                      this.gVLogger.log("if product location called....");
                      this.referenceStatus = false;
                      this.reference = ref;
                      this.productLocation = data.data.locationCode;
                      this.referenceStatus = false;

                      data.data.quantity = data.data.totalQuantityShipmentNotice; //UD

                      if (data.data.id != 0) {
                        if (data.data.qtyONHAND > 0) {
                          // this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                        }

                        let markBadList = [];
                        for(let badInventory of this.badProductConditionsList) {
                          let badProductObj = {
                            code: badInventory.code,
                            type: badInventory.desctiption,
                            quantity: 0,
                            comment: ""
                          };
                          markBadList.push(badProductObj);
                        }

                        data.data.badProductDtoList = markBadList;

                        this.addProductToCart(data.data);
                        this.scrollBottom();
                        // setTimeout(()=>{
                        // event.target.value = "";
                        // event.target.focus();
                        // },500);

                        // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                      } else if (data.data.status === "0") {

                        // this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                        // setTimeout(() => {
                        //   event.target.value = "";
                        //   event.target.focus();
                        // }, 500)

                      }
                      // setTimeout(() => {
                      //   event.target.value = "";
                      //   event.target.focus();
                      // }, 500)
                      //alert("Product added successfully.");


                    } else if (this.cart.items.length >= 1 && (this.reference === null || this.reference === "")) {

                      let refModel = this.modalCtrl.create(LocationCodeModelPage, {
                        title: "Empty Ref#!",
                        message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."
                      });
                      refModel.present();

                      // this.msgManager.toastMsg("Reference# should not be empty!");
                      // setTimeout(() => {
                      //   event.target.value = "";
                      //   event.target.focus();
                      // }, 500)

                    } else if (ref === this.reference || ref === "") {
                      if (ref === this.reference) {
                        this.referenceStatus = false;
                      }

                      data.data.quantity = data.data.totalQuantityShipmentNotice; //UD
                      if (data.data.id != 0) {
                        if (data.data.qtyONHAND > 0) {
                          // this.msgManager.toastMsg("Product with  Barcode: " + barCode + " already received!");
                        }

                        let markBadList = [];
                        for(let badInventory of this.badProductConditionsList) {
                          let badProductObj = {
                            code: badInventory.code,
                            type: badInventory.desctiption,
                            quantity: 0,
                            comment: ""
                          };
                          markBadList.push(badProductObj);
                        }

                        data.data.badProductDtoList = markBadList;

                        this.addProductToCart(data.data);
                        this.scrollBottom();
                        // setTimeout(()=>{
                        // event.target.value = "";
                        // event.target.focus();
                        // },500);

                        // this.gVLogger.log("Barcode : "+ JSON.stringify(data.data));

                      } else if (data.data.status === "0") {

                        // this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
                        // setTimeout(() => {
                        //   event.target.value = "";
                        //   event.target.focus();
                        // }, 500)

                      }
                      // setTimeout(() => {
                      //   event.target.value = "";
                      //   event.target.focus();
                      // }, 500)
                      //alert("Product added successfully.");

                    } else {
                      // this.msgManager.toastMsg("Barcode scanned has a different reference number!");
                      // setTimeout(() => {
                      //   event.target.value = "";
                      //   event.target.focus();
                      // }, 500)
                    }
                  }

                }

              }else if(data.status == "404"){

                // this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
                // setTimeout(()=>{
                //   event.target.value = "";
                //   event.target.focus();
                // },500)

              }
            });
          // setTimeout(()=>{
          //   event.target.value = "";
          //   event.target.focus();
          // },500);
        }
      },400);
    // }


    // setTimeout(()=>{
    //   event.target.value = "";
    //   event.target.focus();
    // },500);
    this.scrollBottom();



  }

  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
       thankyouModal.present();
  }

  presentPaySatusAlert(title,msg){
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title ,message: msg });
       thankyouModal.present();
  }


  holdCart(){
    this.gVLogger.log("Location : " + this.productLocation);
    this.updateButtonStatus = false;
    this.isLoading = false;

    for(let item of this.cart.items){
      if(item.lotNumber === undefined || item.lotNumber === null){
        this.msgManager.toastMsg("Lot# of product with barcode " + item.barCode + " can't be empty!");
        this.updateButtonStatus = true;
        this.isLoading = true;
        return;
      }else {
        if(item.lotNumber.trim() === ""){
          this.msgManager.toastMsg("Lot# of product with barcode " + item.barCode + " can't be empty!");
          this.updateButtonStatus = true;
          this.isLoading = true;
          return;
        }
      }
    }
  if(Number(this.stockCartManager.getProductsCount()) < 1){
    this.msgManager.toastMsg("Can't save empty list.");
    setTimeout(() => {
      this.updateButtonStatus = true;
      this.isLoading = true;
    }, 2000)
         return null;
  }

  let location = this.productLocationCode.trim();
  this.gVLogger.log("Location1 : " + location);

  if(location === ""){

        let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Empty Location!", message: "The location field cannot be left empty. Please enter a valid location."});
         locationModel.present();


    // this.msgManager.toastMsg("Location should not empty!");
    setTimeout(() => {
      this.updateButtonStatus = true;
      this.isLoading = true;
    }, 2000)
    return null;
  }

  try{
    if(this.reference.trim() === ""){
      this.reference = null;
    }

  }catch(err){
    this.gVLogger.log("errrrroeerrrrrr : " + err);

  }


  if(this.autoImportStatus){
    if(this.selectedSupplierCompany.trim() === ""){
      // else if(this.selectedSupplierCompany.trim() === ""){
        let refModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Supplier!", message: "The 'Supplier' field cannot be left empty. Please enter a valid 'Supplier'."});
        refModel.present();

      setTimeout(() => {
        this.updateButtonStatus = true;
        this.isLoading = true;
      }, 2000)
      return null;

      // }
    }
    if(this.po.trim() === "" || this.shipment.trim() === ""){


      this.reference = "";
    }else {
      this.reference = this.po + "---" + this.shipment;
    }
  }else {
    if(this.reference === null){


      let refModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Empty Ref#!", message: "The 'Ref#' field cannot be left empty. Please enter a valid 'Ref#'."});
      refModel.present();

      setTimeout(() => {
        this.updateButtonStatus = true;
        this.isLoading = true;
      }, 2000)
      return null;
    }
  }


            var body:any = this.stockCartManager.receiveStock(100, this.reference, location, this.selectedSupplierCompany); // status 100 for Stock Reading

            let headers = new Headers({
              'Content-Type': 'application/json'
            });
            let options = new RequestOptions({
              headers: headers
            });


            this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
            .subscribe(data => {
              if(data.status === 570 || data.status === 571 || data.status === 403){
                this.presentPaySatusAlert("Failure", data.message);
              }
              else if(data.status === 200 || data.status === 270){

                if(this.autoImportStatus){
                  this.api.post("inventory/updateReceivedStockWithAutoGeneratedShipmentNotice",JSON.stringify(body), options)
                    .map(res => res.json())
                    .subscribe(resp => {
                        if(resp.status==="200"){
                          this.msgManager.toastMsg("Inventory is successfully updated!");
                          this.ionViewDidLoad();
                          this.stockCartManager.clearCart();
                          this.refreshTotalPrice();
                          this.stockCartManager.setOrderTitle("");
                          this.events.publish("titleChange");
                          this.stockCartManager.setShipDate("");
                          this.stockCartManager.setOrderMessage("");
                          this.stockCartManager.setOrderId(0);
                          this.getCustomerCarts(0);
                          // this.referenceStatus = true;
                          // this.po = "";
                          // this.shipment = "";
                          this.selectedSupplierCompany = "";
                          this.stockCartManager.setLocation("");
                          // this.stockCartManager.setReference("");
                          this.updateButtonStatus = true
                          this.isLoading = true

                          //   this.gVLogger.log("updated successfully");
                          // this.nav.setRoot(ItemsPage);

                          this.productLocation = "";
                          this.productLocationCode = "";

                        }
                        else if(resp.status === "403"){
                          this.msgManager.toastMsg(resp.message);
                          this.updateButtonStatus = true
                          this.isLoading = true
                        }else if(resp.status == 401){ // check for session out
                          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                          this.nav.setRoot(LoginPage);
                        }
                        else{
                          this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());
                          this.updateButtonStatus = true
                          this.isLoading = true
                        }



                      }
                      , error =>{
                        // this.gVLogger.log("update call failed");
                      });
                }
                else {
                  this.api.post("inventory/updateReceivedStock",JSON.stringify(body), options)
                    .map(res => res.json())
                    .subscribe(resp => {
                        if(resp.status==="200"){
                          this.msgManager.toastMsg("Inventory is successfully updated!");
                          this.ionViewDidLoad();
                          this.po = "";
                          this.shipment = "";
                          this.stockCartManager.clearCart();
                          this.refreshTotalPrice();
                          this.stockCartManager.setOrderTitle("");
                          this.events.publish("titleChange");
                          this.stockCartManager.setShipDate("");
                          this.stockCartManager.setOrderMessage("");
                          this.stockCartManager.setOrderId(0);
                          this.getCustomerCarts(0);
                          // this.referenceStatus = true;
                          this.stockCartManager.setLocation("");
                          // this.stockCartManager.setReference("");


                          // this.reference = "";
                          this.productLocation = "";
                          this.productLocationCode = "";
                          this.updateButtonStatus = true
                          this.isLoading = true

                          if(this.calledFrom !== null && this.calledFrom !== undefined && this.calledFrom === "workOrder"){
                            this.nav.setRoot(WorkOrdersPage);
                          }
                        }

                        else if(resp.status === "403"){
                          this.msgManager.toastMsg(resp.message);
                          this.updateButtonStatus = true
                          this.isLoading = true
                        }
                        else if(resp.status == 401){ // check for session out
                          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                          this.reference = "";
                          this.productLocation = "";
                          this.productLocationCode = "";

                          this.nav.setRoot(LoginPage);
                        }
                        else{
                          this.reference = "";
                          this.productLocation = "";
                          this.productLocationCode = "";
                          this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());
                          this.updateButtonStatus = true
                          this.isLoading = true
                        }



                      }
                      , error =>{
                        // this.gVLogger.log("update call failed");
                      });
                }

              }
            });
  }


   // go to search page
  goToSearch() {
    this.menuController.close("testRightMenu");
    this.nav.push(SearchPage);
  }
   goToCustomerWishList(){
	this.nav.push(CustomerWishListPage);
  }

  refreshTotalPrice(){
     this.cart = STOCKCART;
     let temp:number = 0;
     for(let item of this.cart.items){
         temp =  temp +  Number(item.quantity);
         item.lotNumber = "1"
     }
     this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
     this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
     //alert(JSON.stringify(this.cart));
  }

addProductToCart(item){
  this.stockCartManager.addProductToCart(item);
  this.refreshTotalPrice();
  return true;
}

  addProductToCartFromPopUp(item){
    this.gVLogger.log("FFFFFFFFFFFFFFFFFFF " + item)
    this.stockCartManager.addProductToCartFromPopUp(item);
    this.refreshTotalPrice();
    return true;
  }


removeProductFromCart(product){

  this.stockCartManager.removeOneNew(product);

  this.refreshTotalPrice();
}


  cameraBarcodeScanner(){

    this.gVLogger.log("Camera barcode Scanner");
    BarcodeScanner.scan().then((barcodeData) => {
        this.msgManager.startLoading();

      if (!barcodeData.cancelled) {

      this.api.get("/products/barcode/"+barcodeData.text+"?isWebStore="+this.isWebstore)
      .map(res => res.json())
      .subscribe(data => {

        this.msgManager.stopLoading();
        if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }else if(data.status == 200){
            if(data.data.id != 0){
              this.stockCartManager.addProductToCart(data.data);
            }

          }
        }, (err)=>{
          this.msgManager.stopLoading();
        });

    }else{
      this.msgManager.stopLoading();
    }


    }, (err) => {
      this.msgManager.stopLoading();

    });

  }


  deleteProductFromCart(product){

  this.gVLogger.log("detete caled....");
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: "Are you sure you want to delete '"+product.name+"' from the cart?",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
          //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
           // this.gVLogger.log('Agree clicked');
            this.stockCartManager.deleteProductFromCart(product);
            this.refreshTotalPrice();
            this.checkReferenceTypeOfCartProducts();
          }
        }
      ]
    });
    confirm.present();
  }
clearCart(){
    let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'You want to clear all the products from cart',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
            //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
             // this.gVLogger.log('Agree clicked');
              this.stockCartManager.clearCartProducts();
              this.refreshTotalPrice();
            }
          }
        ]
      });
      confirm.present();
  }

  onFocusBarcode(event){
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }
  onBlurBarcode(event){
    event.target.value = "";

    this.barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  }


  onFocusLocation(event){
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }
  onBlurLocation(event){
    event.target.value = "";

    this.barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  }

  activateBarcodeField(){
//this.gVLogger.log("activateBarcodeField Loaded");
    setTimeout(() => {
      // Keyboard.show() // for android
      this.barCodeFocusInput.setFocus();
    },0); //a least 150ms.
  }

  locationSelectedChange(event){
     //alert(this.locationSelected);
  }

  imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }

  discardCart(){// TODO: Check if order contains ID delete on Server else Delete local
    this.stockCartManager.setLocation("");
    this.stockCartManager.setReference("");
    if(Number(this.stockCartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't reset empty list.");
      this.productLocation = "";
      this.productLocationCode = "";
      // this.productWarehouse = "";
      // this.productWarehouseId = 0;
      this.po = "";
      this.shipment = "";
      this.selectedSupplierCompany = "";
      this.referenceStatus = true;
      this.reference = "";
           return null;
           //UD

    }
    else{
    this.menu.close('testRightMenu');
    // alert(this.stockCartManager.getProductsCount());
    let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'You want to discard this Cart',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
            //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
             // this.gVLogger.log('Agree clicked');
             this.reference = "";
              this.po = "";
              this.shipment = "";
              this.supplierName = "";
             this.productLocation = "";
             this.productLocationCode = "";
              // this.productWarehouse = "";
              // this.productWarehouseId = 0;
             this.referenceStatus = true;

              if(this.stockCartManager.getOrderId() == 0){
                this.gVLogger.log("Local Order");
                this.stockCartManager.clearCartProducts();
                this.stockCartManager.setOrderTitle("");
                this.events.publish("titleChange");
                this.stockCartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.getCustomerCarts(0);
                this.stockCartManager.setLocation("");
                this.stockCartManager.setReference("");

              }else{
                // TODO: send call to server

                let body = "?orderId="+this.stockCartManager.getOrderId()+"&customerId="+this.stockCartManager.getSalesManId();

                this.api.post("order/discard"+body,null).map(res => res.json()).subscribe(result=>{
                    if(result.status == 200){
                      this.stockCartManager.clearCartProducts();
                      this.stockCartManager.setOrderTitle("");
                      this.stockCartManager.setOrderId(0);
                      this.refreshTotalPrice();
                      this.getCustomerCarts(0);
                      this.stockCartManager.setLocation("");
                      this.stockCartManager.setReference("");

                    }else if(result.status == "401"){ // check for session out
                      this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                      this.nav.setRoot(LoginPage);
                    }
                });

              }

            }
          }
        ]
      });
      confirm.present();
    }
  }



  scrollBottom(){
    setTimeout(()=>{
      this.content.scrollToBottom(200);
    },400)

  }
  scrollToItem(yOffset){
    this.content.scrollTo(0, yOffset, 200);
  }

  toggleRignt(){

    this.menu.toggle('testRightMenu');
  }

  getCustomerCarts(startPoint){


  let body = "?customerId="+this.stockCartManager.getCustomerID()+"&startPoint="+startPoint;
    this.api.post("order/loadByCustomer"+body,null)
    .map(res => res.json())
    .subscribe(data => {
      if(data.status == 200){

        this.customerCarts.setCustomerCarts(data.data);
        let cartsOnhold:number = 0;
        for(let cart of data.data){
          if(cart.orderStatus == 100) {
            cartsOnhold += 1;
          }
        }
      //  this.gVLogger.log(data);
        if(cartsOnhold > 0){
          this.multipleCarts = true;
        }
      }else if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else {
        this.msgManager.toastMsg(data.message);
         }
      });
  }


discountCheck(discountPrice){
    // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }


  getNumber(val: any) {
    if (isNaN(val)) return 0;
    return +val;
  }

  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage(){
  this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage(){
     this.nav.setRoot(MyOrderPage);
  }
  logOut(){
     this.nav.setRoot(LoginPage);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: product, "status" : "fromReceiveStock"});
  }

  holdCartResolver(){
    this.updateButtonStatus = false;
    this.isLoading = false;
  	if (this.isOfflineMode) {
  		this.holdOrderOffline();
  	}else{
  		this.holdCart();
  	}
  }


  holdOrderOffline(){


  		if(Number(this.stockCartManager.getProductsCount()) < 1){
        this.msgManager.toastMsg("Can't Save empty list.");
		       return null;
		  }


		  if(!Constants.isWebstore && this.stockCartManager.getOrderTitle() == "" ){
let prompt = this.alertCtrl.create({
      title: 'Please enter stock location info',
      inputs: [
        {
          name: 'location',
          placeholder: 'Name or Location'
        },
        {
          name: 'aisle',
          placeholder: 'Aisle'
        },
        {
          name: 'shelf',
          placeholder: 'Shelf'
        },
        {
          name: 'bin',
          placeholder: 'Bin'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          //  this.gVLogger.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

            var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

      this.apiOffline.insertOrder(JSON.stringify(body))
              .then((data) => {
                  this.stockCartManager.clearCart();
                  this.stockCartManager.setOrderTitle("");
                  this.events.publish("titleChange");
                  this.stockCartManager.setOrderMessage("");
                  this.stockCartManager.setOrderId(0);
                  this.stockCartManager.setOrderStatus(0);
                  this.refreshTotalPrice();
                  // this.nav.setRoot(ItemsPage);
      this.getCustomerCarts(0);

              })
              .catch(e => this.gVLogger.log(e));

          }
        }
      ]
    });
    prompt.present();
  }else{



  	 var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock readiung

      this.apiOffline.insertOrder(JSON.stringify(body))
              .then((data) => {

                  this.stockCartManager.clearCart();
                  this.stockCartManager.setOrderTitle("");
                  this.stockCartManager.setOrderMessage("");
                  this.events.publish("titleChange");
                  this.stockCartManager.setOrderId(0);
                  this.stockCartManager.setOrderStatus(0);
                  this.refreshTotalPrice();
                  this.events.publish("titleChange");
                  // this.nav.setRoot(ItemsPage);
      this.getCustomerCarts(0);

              })
              .catch(e => this.gVLogger.log(e));
  }


  }

//   makeImageURL(dimensions,item){
//   return this.stockCartManager.makeImageURL(dimensions,item);
// }


getCSVFromCARTItems(){

  let temp =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});


  return this.stockCartManager.ConvertToCSV(temp);

}

emailCSV(){


  // /intelliStock/emailService

  let temp = this.stockCartManager.getOrderTitle().split("||");

    let location = temp[0];
    let aisle = temp[1];
    let shelf = temp[2];
    let bin = temp[3];

  let prompt = this.alertCtrl.create({
    title: 'Please enter stock location info',
    inputs: [
      {
        name: 'location',
        placeholder: 'Name or Location',
        value: location
      },
      {
        name: 'aisle',
        placeholder: 'Aisle',
        value: aisle
      },
      {
        name: 'shelf',
        placeholder: 'Shelf',
        value: shelf
      },
      {
        name: 'bin',
        placeholder: 'Bin',
        value: bin
      },
    ],
    buttons: [
      {
        text: 'Cancel',
        handler: data => {
        //  this.gVLogger.log('Cancel clicked');
        }
      },
      {
        text: 'Email',
        handler: data => {
        //  this.gVLogger.log(data.title);
          // this.cartManager.setOrderTitle(data.title);
          this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

          var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

          let headers = new Headers({
            'Content-Type': 'application/json'
          });
          let options = new RequestOptions({
            headers: headers
          });
            this.api.post("order/place",JSON.stringify(body), options)
            .map(res => res.json())
            .subscribe(resp => {

              this.api.postJazzba('intelliStock/emailService',{
                email: this.stockCartManager.getSalesPerson().email,
                subject:this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle()),
                fileText: this.getCSVFromCARTItems(),
                filename:"StockReading",

              })
              .map(res=>res.json())
              .subscribe((result)=>{
                if(result.status == 200){
                  this.stockCartManager.clearCart();
                  this.stockCartManager.setOrderTitle("");
                  this.events.publish("titleChange");
                  this.stockCartManager.setOrderMessage("");
                  this.stockCartManager.setOrderId(0);
                  this.stockCartManager.setOrderStatus(0);
                  this.refreshTotalPrice();

                  this.api.toastMSG(result.message);

                }else{
                  this.api.toastMSG(result.message);
                }
              }, (error)=>{
                this.gVLogger.log(error);
              })



                // this.nav.setRoot(ItemsPage);
    this.getCustomerCarts(0);

            })

        }
      }
    ]
  });
  prompt.present();


  // this.file.writeFile(this.file.applicationDirectory, 'test.csv', this.getCSVFromCARTItems(), {replace: true})
  //    .then(() => {
  //      alert("File saved");
  //      let email = {
  //        to: 'gsn.ahmad@gmail.com',
  //        attachments: [
  //          this.file.applicationDirectory + 'test.csv'
  //        ],

  //        subject: 'Test',
  //        body: 'CSV test email...',
  //        isHtml: true
  //      };
  //      this.emailComposer.open(email);

  //    })
  //    .catch((err) => {
  //      alert(JSON.stringify(err));
  //    });

}

saveAsCsv() {
  var blob = new Blob([this.getCSVFromCARTItems()]);
  var a = window.document.createElement("a");
  a.href = window.URL.createObjectURL(blob);
  a.download = "newdata.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}


checkLocationCodeExist(){
  this.updateButtonStatus = false;
  this.isLoading = false;
  this.gVLogger.log("checkLocationCodeExist called");

  let location = this.productLocation.trim();
  // let warehouse = this.productWarehouse.trim();


    if(location === ""){
    let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Empty Location!", message: "The location field cannot be left empty. Please enter a valid location."});
    locationModel.present();
    // this.msgManager.toastMsg("Location should not empty!");
    setTimeout(() => {
      this.updateButtonStatus = true;
      this.isLoading = true;
    }, 2000)
  }

  else {
    // let locationSplitted = this.productLocation.split("(");
    // let locationCode = locationSplitted[1].split(")");

    // else{
    // this.api.get("/inventory/checkIfLocationExist?locationCode="+ this.productLocation)
    // this.api.get("/inventory/checkIfLocationExist?locationCode="+ locationCode[0])
    //   .map(res => res.json())
    //   .subscribe(data => {
        if(location === ""){
          let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Empty Location!", message: "The location field cannot be left empty. Please enter a valid location."});
          locationModel.present();
          // this.msgManager.toastMsg("Location should not empty!");
          setTimeout(() => {
            this.updateButtonStatus = true;
            this.isLoading = true;
          }, 2000)
        }

        else {
          this.holdCartResolver();
        }

  }


  }

  getLookupBadProductConditions(){
    this.api.get("lookup/codesByTable?tableName=badProductConditions").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.badProductConditionsList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
    });

  }

  chooseFromLocations(product){
    this.gVLogger.log("LicenseStatusModelPage" +  JSON.stringify(product));
    let backup = JSON.stringify(product);
    this.gVLogger.log("LicenseStatusModelPageeeee" +  this.cart);

    // let markBadList = [];
    // for(let badInventory of this.badProductConditionsList) {
    //   let badProductObj = {
    //     code: badInventory.code,
    //     type: badInventory.desctiption,
    //     quantity: 0,
    //     comment: ""
    //   };
    //   markBadList.push(badProductObj);
    // }
    //
    // product.badProductDtoList = markBadList;


    let productLocationsModel = this.modalCtrl.create(MarkBadProductModelPage, {item: product}, {cssClass: 'receiceStockModall'});
    productLocationsModel.onDidDismiss(dataFromMarkBadProductModel => {
      // this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);


      // if(dataFromMarkBadProductModel !== null && dataFromMarkBadProductModel !== undefined){
      //
      //   this.gVLogger.log("Data from product location model in pickpack list : " + JSON.stringify( dataFromMarkBadProductModel));
      //   product.badProductDtoList = dataFromMarkBadProductModel;
      // }
    })
    productLocationsModel.present();
    // }
    // });

  }


  makeImageURL(dimensions,item){
    if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
      if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else{
        return "./assets/img/dummy-"+dimensions+".png";
      }
    }else{
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
      return this.cartManager.makeImageURL(dimensions,item);
    }
  }

  getFallBackImage(dim) {
    if (this.constants.isWebstore) {
      return this.cartManager.makeNANImageURLFromImage(dim);

    } else {
      return "./assets/img/dummy-" + dim + ".png";
    }
  }


  onChangeAutoImportStatus(){
    if(this.cart.items.length > 0){
      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'Cart will be discarded',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
              // this.gVLogger.log('Agree clicked');
              if(this.autoImportStatus){

                // if(!this.referenceStatus){
                //
                // }
                this.autoImportStatus = false;
                // this.shipment = "";
                // this.po = "";
              }else {

                this.autoImportStatus = true;
                // this.reference = "";
              }
              this.reference = "";
              this.po = "";
              this.shipment = "";
              this.productLocation = "";
              this.productLocationCode = "";
              // this.productWarehouse = "";
              // this.productWarehouseId = 0;
              this.referenceStatus = true;

              if(this.stockCartManager.getOrderId() == 0){
                this.gVLogger.log("Local Order");
                this.stockCartManager.clearCartProducts();
                this.stockCartManager.setOrderTitle("");
                this.events.publish("titleChange");
                this.stockCartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.getCustomerCarts(0);
                this.stockCartManager.setLocation("");
                this.stockCartManager.setReference("");

              }else{
                // TODO: send call to server

                let body = "?orderId="+this.stockCartManager.getOrderId()+"&customerId="+this.stockCartManager.getSalesManId();

                this.api.post("order/discard"+body,null).map(res => res.json()).subscribe(result=>{
                  if(result.status == 200){
                    this.stockCartManager.clearCartProducts();
                    this.stockCartManager.setOrderTitle("");
                    this.stockCartManager.setOrderId(0);
                    this.refreshTotalPrice();
                    this.getCustomerCarts(0);
                    this.stockCartManager.setLocation("");
                    this.stockCartManager.setReference("");

                  }else if(result.status == "401"){ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    this.nav.setRoot(LoginPage);
                  }
                });

              }

            }
          }
        ]
      });
      confirm.present();
    }else {
      if(this.autoImportStatus){

        // if(!this.referenceStatus){
        //
        // }
        this.autoImportStatus = false;
        // this.shipment = "";
        // this.po = "";
      }else {

        this.autoImportStatus = true;
        // this.reference = "";
      }
    }

  }

  getSuppliersOnFocus() {

    if(this.locationPopUpOpenStatus == false && loginUserInfo.customerType === "Supplier"){
      this.locationPopUpOpenStatus = true;
      this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

      let loc = "";

      loc = "-1";

      this.api.get("supplier/getAllSuppliers")
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            this.suppliers = [];
            for(let item of data.data){
              // let loc = item.name + " (" + item.locationCode + ")";

              // let loc = {id : item.id, company : item.compay}
              this.suppliers.push(item);
              this.gVLogger.log("daaaattaaaaa : " + this.items);
            }

            let model = this.modalController.create(SuppliersListPage, {items: this.suppliers, searchString: loc});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                // this.productLocation = data;
                this.selectedSupplier = data;
                this.selectedSupplierCompany = data.company;
                // this.productLocationCode = data.locationCode;
                this.stockCartManager.setSupplier(data);

              }
              else {

              }
            });
            model.present();

            this.items = [];
          }

        });

      setTimeout(() => {
        this.locationPopUpOpenStatus = false;
      },500)


    }
    else{

    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/stockcart/stockcart.ts